/**
 *  使用 ANTD PRO 布局
 */
import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter,
} from "react-router-dom";
import {ConfigProvider, Spin} from "antd";
import Auth from "@utils/auth";
import ReactContext from "@store/reactContext";
import Cookie from "@utils/cookie";
import {routes} from "@config/routes";
import Index from "@pages/Index/Index/index";
import SinglePage from "@pages/Single/SingleRouter";
import {isEmpty} from '@utils/utils';
import {postMenus,getAuthButton,postMenusRedPoint,getUserExtra} from '@/api/user'
import 'remixicon/fonts/remixicon.css'
import eventProxy from '@/utils/eventProxy'
import BasicLayout from "./BasicLayout";
import "./AppPro.less";
import localeCN from 'antd/locale/zh_CN';
import localeRU from 'antd/locale/ru_RU';
import localeEN from 'antd/locale/en_US';
import dayjs from 'dayjs';
import Locale from "@utils/locale";
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';
const localeLang = Locale.current();

dayjs.locale(localeLang=="zh"?"zh-cn":localeLang);
/**
 * 路由组件
 */
const handleSon = function(list) { //扩展多级路由
    let sonRouter = []
    list.forEach(item=>{
        if (item.routes){ //子路由
            const list = handleSon(item.routes);
            sonRouter = [...sonRouter,...list];
        }
        sonRouter.push(<Route
            path={item.path}
            component={item.component}
            key={item.id+'-'+item.path}
        />)
    })
    return sonRouter;
}
const Routes = function (menus) {
    // console.log('menus',menus);
    let allRoutes = [];
    let key = 0;
    // 默认路由
    // const defaultPath = Object.keys(menus||{})[0]
    for (const first of routes) {
        // 二级路由
        if (first.routes) {
            const list = handleSon(first.routes);
            allRoutes = [new Set([...allRoutes,...list])];
        }
        // 一级路由
        allRoutes.push(
            <Route path={first.path} component={first.component} key={++key}/>
        )
        // const NewComponent = require('../'+first.component).default;
        // allRoutes.push(
        //     <Route path='first.path' render={(routeProps) => {
        //         //routeProps就是路由组件传递的参数
        //         console.log("routeProps",routeProps)
        //         return NewComponent
        //     }} />
        // )
    }
    // 默认路由
    allRoutes.push(<Route component={Index} key={++key}/>);
    return <Switch>{allRoutes}</Switch>;
};

class AppPro extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            userName: "",
            showMenu:true,
            routes: [],
            menus: [],
            loading: false,
            redPointDigital:{}
        }
    }

    logout() {
        Auth.logout();
        this.props.history.push("/login");
    }
    //处理接口菜单 为 pro接收的菜单 配置
    handleMenusFormat(data = []){
        data.forEach(item=>{
            item.path = item.routing;
            if(item.submenuList){
                item.routes = item.submenuList||[];
                this.handleMenusFormat(item.routes)
            }
        })
        return data;
    }
    // 获取菜单
    getMenus() {
        postMenus().then((res={}) => {
            const models = res.data&&res.data.models?res.data.models:[]
            // const menus = outOfRouting(serverMenuList);
            const serverMenuList = this.handleMenusFormat(models)
            this.setState({
                routes: models,
                menus: serverMenuList,
                loading: false,
            }, () => {
                this.getMenusRedPoint(serverMenuList)
                // 订阅 getMenusRedPoint
                eventProxy.on('getMenusRedPoint', this.getMenusRedPoint.bind(this, res.data.models))

                const pathname = window.location.pathname
                if (models.length>0 && (pathname==='/'||pathname==='/dop'||pathname==='/dop/')) {
                    let path = ''
                    if (models.submenuList&&models.submenuList.length>0) {
                        path = models.submenuList[0].routing
                    } else {
                        path = models.routing
                    }
                    eventProxy.emit('redirectPage', path)
                }
            });
        })
    }
    // 获取权限按钮
    getUserButton(){
        getAuthButton().then((res={}) => {
            const data = res.data || {};
            const {success,valid, models } = data;
            if(success&&valid){
               this.setState({
                   authButton:  models
               })

            }

        })
    }
    /**
     *  获取小红点
     **/
    getMenusRedPoint(menus){
        postMenusRedPoint().then((res={}) => {
            const redPointDigital = res.data&&res.data.model || {};
            this.setState({
                // menus: menus,
                redPointDigital:redPointDigital
            })
        })
    }
    userExtra(){
        const userExtra  = Cookie.getJSON("fmg.extra") || {};
        this.loading(true)
        if(!isEmpty(userExtra.userId)){
            getUserExtra({
                id:  userExtra.userId
            }).then((res={}) => {
                const resData = res.data||{};
                const userExtraState = {...userExtra, ...resData.model}; // 最新的 extra
                Cookie.set("fmg.extra",userExtraState );
                this.setState({
                    _extraState:userExtraState,// 需要 放到 数据仓库同步所有页面
                },()=>{
                    this.loading(false)
                })
            })
        }
    }
    loading(flag){
        this.setState({
            loadingExtra:flag
        })
    }
    componentWillMount() {
        this.userExtra()
    }

    componentDidMount() {
        const {userName,positionCode} = Cookie.getJSON("fmg.extra") || {};
        this.setState({
            userName: userName,
            loading: true,
        });
        window.setUserName = (data) => {
            this.setState({
                userName: data || userName,
            });
        };
        this.getMenus();
        this.getUserButton();
    }
    render() {
        const {history} = this.props;
        const {userName,authButton, menus,redPointDigital,loading,_extraState={},loadingExtra=false} = this.state;

        // const selectObj = this.getDefaultSelectedKeys()
        // const defaultSelectedKeys = selectObj.defaultSelectedKeys;
        return (<ConfigProvider theme={{
                token: {
                    colorPrimary: '#A4373A',
                    fontFamily: 'Rubik',
                    lineHeight: 1.5,
                },
                components: {
                    Button: {
                        boxShadow:"none",
                    }
                },
            }}
                                locale={localeLang=="ru"?localeRU:(localeLang=="en"?localeEN:localeCN)}
            >
                <Spin spinning={loadingExtra}>
                <ReactContext.Provider  value={{
                    __authState: authButton,
                    _extraState:_extraState
                }}>
                <Router>
                    <Switch>
                        <Route path="/act">
                            <SinglePage />
                        </Route>
                        <Route path="/">
                            <BasicLayout className={`App-main-layout la-`+localeLang}
                                         menuData={menus}
                                         loading={loading}
                                         // selectedMenuKeys={defaultSelectedKeys}
                                         redPointDigital={redPointDigital}
                                         userName={userName}
                                         history={history}>
                                {Routes(this.state.menus)}
                            </BasicLayout>
                        </Route>
                    </Switch>
                </Router>
                </ReactContext.Provider>
                </Spin>
            </ConfigProvider>
        );
    }
}

export default withRouter(AppPro);
